import { useSelector } from 'react-redux';
import ComponentsArrRenderer from './ComponentsArrRenderer';
import {
  useIsActive as useIsPagePreviewActive,
  useIfHideAppFooter
} from '../../modules/page-preview';
import { useIsActive, useIsLayerTerminal } from '../Others/layerControl/hooks';
import { useIsActiveByName, useSettingsByName } from '../../modules/hooks';
import { emptyNull } from '../../shared/misc';

const AppFooter = (props) => {
  const { isActive: isAppFooterActive, components } = useSelector(
    (state) => state.appState.settings?.appFooter
  ) ?? emptyNull;

  // LayerControl
  const layerControlIsActive = useIsActive();
  const isLayerTerminal = useIsLayerTerminal();
  // Terminal
  const { appFooterImage } = useSettingsByName('terminal') ?? {};
  const isTerminalActive = useIsActiveByName('terminal');
  const isTerminalMode = Boolean(layerControlIsActive && isTerminalActive && isLayerTerminal);

  const isPagePreviewActive = useIsPagePreviewActive();
  const ifHideAppFooter = useIfHideAppFooter();
  const { pathname, search, hash } = window.location;
  const windowLocationRelative = `${pathname}${search}${hash}`;

  if (!isAppFooterActive) return null;
  if (isPagePreviewActive && ifHideAppFooter(windowLocationRelative)) return null;

  if (isTerminalMode) {
    // In terminal mode we should show footer image or hide the AppFooter components
    if (!appFooterImage) return null;
    return (
      <div className="app-footer-terminal-mode">
        <img
          className="app-footer-terminal-mode-image"
          src={appFooterImage}
          alt="Terminal App Top"
          style={{ width: '100%', height: '250px', objectFit: 'cover' }}
        />
      </div>
    );
  }

  return <ComponentsArrRenderer {...props} components={components} />;
};

export default AppFooter;
